import { render, staticRenderFns } from "./BlockType24.vue?vue&type=template&id=0e10b5b4&scoped=true&"
import script from "./BlockType24.vue?vue&type=script&lang=ts&"
export * from "./BlockType24.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType24.vue?vue&type=style&index=0&id=0e10b5b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10b5b4",
  null
  
)

export default component.exports